const topicTags = [
  { tag: '#科幻巨制', count: '2.3万讨论', hot: true },
  { tag: '#国剧黑马', count: '1.8万讨论', hot: true },
  { tag: '#悬疑烧脑', count: '1.6万讨论', hot: true },
  { tag: '#高分韩剧', count: '1.4万讨论', hot: false },
  { tag: '#漫威宇宙', count: '1.2万讨论', hot: false },
  { tag: '#国产动漫崛起', count: '9800讨论', hot: false },
  { tag: '#治愈系电影', count: '8700讨论', hot: false },
  { tag: '#经典重映', count: '7600讨论', hot: false },
  { tag: '#暑期档推荐', count: '3.1万讨论', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            话题热议
          </h2>
          <p className="mt-2 text-sm text-foreground-500">影迷社区热门讨论，发现更多精彩内容</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 border border-background-200/60 hover:border-accent-300 hover:bg-accent-50/50 transition-all cursor-pointer no-underline"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.tag}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
              {item.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}